import { usePaginatedList } from '@core/hooks/usePaginatedList';
import { districtListService } from '../services/districtSvc';
import { District, DistrictQueryParams, DistrictMeta } from '../types/district';

interface UseDistrictsResult {
  districts: District[];
  loading: boolean;
  error: string | null;
  pagination: DistrictMeta | null;
  refetch: () => void;
  updateParams: (newParams: Partial<DistrictQueryParams>) => void;
  validationErrors: string[];
}

export const useDistricts = (initialParams: DistrictQueryParams = {}): UseDistrictsResult => {
  const { items, ...rest } = usePaginatedList<District, DistrictQueryParams, DistrictMeta>(
    districtListService,
    initialParams,
    {
      filterResetFields: ['freetext', 'districtName', 'churchName'],
      normalizeKeys: ['freetext', 'districtName', 'churchName'],
      entityLabel: 'districts',
    }
  );

  return { districts: items, ...rest };
};
